import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number, isPrivate: boolean = false): string {
  if (isPrivate) {
    return 'Rs ****';
  }
  return new Intl.NumberFormat('en-PK', {
    style: 'currency',
    currency: 'PKR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)
}

export function formatCurrencyCompact(amount: number, isPrivate: boolean = false): string {
  if (isPrivate) {
    return 'Rs ****';
  }
  return new Intl.NumberFormat('en-PK', {
    style: 'currency',
    currency: 'PKR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Math.round(amount))
}

export function formatNumber(num: number, decimals: number = 2): string {
  return new Intl.NumberFormat('en-PK', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num)
}

export function formatPercent(num: number, decimals: number = 2): string {
  return `${num >= 0 ? '+' : ''}${formatNumber(num, decimals)}%`
}

export function formatDate(date: Date | string): string {
  return new Intl.DateTimeFormat('en-PK', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(date))
}

export function formatWeight(weight: number | string, decimals: number = 4): string {
  const numWeight = typeof weight === 'string' ? parseFloat(weight) : weight;
  return `${formatNumber(numWeight, decimals)} tola${numWeight !== 1 ? 's' : ''}`;
}
